import { render, staticRenderFns } from "./TimedPriceChangeModal.vue?vue&type=template&id=da9d0ca6&scoped=true"
import script from "./TimedPriceChangeModal.vue?vue&type=script&lang=ts"
export * from "./TimedPriceChangeModal.vue?vue&type=script&lang=ts"
import style0 from "./TimedPriceChangeModal.vue?vue&type=style&index=0&id=da9d0ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9d0ca6",
  null
  
)

export default component.exports